"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AdminAccess = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5.29289322,17 L10.7928932,11.5 L10.1464466,10.8535534 C8.57047259,9.27757937 8.57047259,6.72242063 10.1464466,5.14644661 C11.7224206,3.57047259 14.2775794,3.57047259 15.8535534,5.14644661 L17.8535534,7.14644661 C19.4295274,8.72242063 19.4295274,11.2775794 17.8535534,12.8535534 C16.2775794,14.4295274 13.7224206,14.4295274 12.1464466,12.8535534 L11.5,12.2071068 L8.70744279,14.999664 L10.8605957,17.1487282 C11.0558578,17.3439903 11.0558578,17.6605728 10.8605957,17.855835 C10.6653336,18.0510971 10.3487511,18.0510971 10.1534889,17.855835 L8.00033601,15.7067708 L6.70744279,16.999664 L8.8605957,19.1487282 C9.05585785,19.3439903 9.05585785,19.6605728 8.8605957,19.855835 C8.66533356,20.0510971 8.34875107,20.0510971 8.15348892,19.855835 L6.00033601,17.7067708 L5.29289322,17 Z M10.8535534,5.85355339 C9.66810366,7.03900312 9.66810366,8.96099688 10.8535534,10.1464466 L12.8535534,12.1464466 C14.0390031,13.3318963 15.9609969,13.3318963 17.1464466,12.1464466 C18.3318963,10.9609969 18.3318963,9.03900312 17.1464466,7.85355339 L15.1464466,5.85355339 C13.9609969,4.66810366 12.0390031,4.66810366 10.8535534,5.85355339 Z M12.8527216,7.1426709 L15.8571045,10.1468003 C16.0523667,10.342046 16.05238,10.6586151 15.8571344,10.8538772 C15.6618549,11.0491567 15.3452705,11.0491634 15.1499977,10.8539071 L12.1456148,7.84977768 C11.9503527,7.65453201 11.9503393,7.33796288 12.145585,7.14270073 C12.3408645,6.94742126 12.6574488,6.94741458 12.8527216,7.1426709 Z" })));
};
AdminAccess.displayName = 'AdminAccess';
exports.default = AdminAccess;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AdminAccess.js.map